import { Autocomplete, CircularProgress, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { TextValidator } from "react-material-ui-form-validator";
import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { IDropdownData } from "../../_common/interface/dropdown/iDropdownData.interface";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
    isTiny?: boolean;
    open?: boolean
    onOpen?(event: React.SyntheticEvent): void,
    disableCloseOnSelect?: boolean,
    itemsLoader: (parentId?: number | string) => Promise<any>,
    label: string
}

export default function StandardAutoComplete(params: IStandardExtAutocomplete) {
    const [value, setValue] = useState<IDropdownData | null>();
    const [inputValue, setInputValue] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [items, setItems] = useState<Array<any>>([]);
    const [excludedIds, setExcludedIds] = useState<Array<number | string>>(
        params.excludedIds || []
    );

    useEffect(() => {
        if (params.excludedIds != excludedIds) {
            setExcludedIds(params.excludedIds ? params.excludedIds : []);
        }
    }, [params.excludedIds]);

    useEffect(() => {
        if (params.hasParent === true) {
            if (!!params.parentId) {
                fetchItems(params.parentId);
            } else if (items.length > 0) {
                setItems([]);
                changeInput(null);
            }
        } else {
            fetchItems();
        }
    }, [params.parentId]);

    useEffect(() => {
        if (items && items.length > 0) {
            changeInput(items.find((_item: any) => _item.id === params.itemId));
        } else if (
            ((!items || items.length === 0) && value) ||
            ((!params.itemId || params.itemId === 0) && value)
        ) {
            changeInput(null);
        }
    }, [items, params.itemId]);

    function fetchItems(parentId?: number | string) {
        setLoading(true);
        return params
            .itemsLoader(parentId)
            .then(
                (json) => {
                    if (!json || json.length < 1) {
                        setItems([]);
                    } else {
                        setItems(json);
                    }
                },
                (err) => {
                    setItems([]);
                }
            )
            .finally(() => setLoading(false));
    }

    function changeInput(newValue: any) {
        newValue = newValue ? newValue : null;
        if (newValue === value) return;
        setValue(newValue);
        params.onItemChange?.({ target: { name: params.name, value: newValue?.id } }, newValue, params.name);
    }

    return (
        <Autocomplete
            open={params.open}
            onOpen={params.onOpen}
            id="tags-standard"
            fullWidth
            options={excludedIds && excludedIds.length ? items.filter(m => m.id === value || !excludedIds.some(r => r === m.id.toString())) : items}
            getOptionLabel={(option) => option.name}
            value={value || null}
            onChange={(event: any, newValue: any) => {
                changeInput(newValue);
            }}
            inputValue={inputValue || ''}
            onInputChange={(event: any, newInputValue: any) => {
                setInputValue(newInputValue);
            }} renderInput={(props) => (
                <TextValidator
                    value={inputValue}
                    {...props}
                    label={`${params.label} ${params.isRequired === true ? "*" : ""}`}
                    autoComplete="new-password"
                    name={`${params.name}`}
                    validators={params.isRequired === true ? ['required'] : []}
                    errorMessages={params.isRequired === true ? ['This field is required'] : []}
                    variant={params.variant || "filled"}
                    type="text"
                    disabled={params.disabled || false}
                    InputProps={{
                        ...props.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {props.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />)}
        />
    )

}
